import { useState } from "react";
import { useLocation } from "react-router-dom";
import SideNav from "./components/SideNav/sideNav";
import { Layout } from "antd";
import { RoutesList } from "./components/routes";
import { useAuth } from "./utils/hooks/useAuth";
import AppHeader from "./components/AdvisoryHeader/AdvisoryHeader";
import { ScrollToTop } from "./components/ScrollToTop";

// Standalone form routes that should bypass all app logic
const STANDALONE_FORM_ROUTES = [
  "/verify-phone",
  "/select-address",
  "/sample-request-form",
  "/form-unavailable",
  "/sample-order-form",
];

const App = () => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  const [background, setBackgroundImage] = useState<any>({
    background: "white",
  });

  // Check if current route is a standalone form
  const isStandaloneForm = STANDALONE_FORM_ROUTES.includes(
    location.pathname.toLowerCase()
  );

  // For standalone forms, render without any app layout or auth checks
  if (isStandaloneForm) {
    return (
      <Layout
        style={{
          minHeight: "100vh",
          background: "transparent",
        }}
      >
        <RoutesList setBackgroundImage={setBackgroundImage} />
      </Layout>
    );
  }

  // Regular app layout with auth checks
  return (
    <Layout
      style={{
        maxHeight: "100svh",
        ...(!isAuthenticated && { overflowY: "hidden" }),
      }}
    >
      {isAuthenticated &&
        window.location.href.split("/").pop() !== "verify-otp" && <AppHeader />}
      <Layout
        className="inner-layout custom-scroller"
        style={{
          padding: "0 0",
          overflowX: "hidden",
          height: !isAuthenticated ? "calc(100svh - 64px)" : "100svh",
          flexDirection: "row",
          alignItems: "baseline",
          ...background,
        }}
      >
        <ScrollToTop />
        {isAuthenticated &&
          window.location.href.split("/").pop() !== "verify-otp" && <SideNav />}
        <RoutesList setBackgroundImage={setBackgroundImage} />
      </Layout>
    </Layout>
  );
};

export default App;
